export default {"src":"/_next/static/media/logo.0280e2cf.svg","height":1061,"width":2739};